export const numberFromDate = (value: string | number): number => {
  const startTimeToNumber = new Date(value).getTime();

  if (!startTimeToNumber) {
    return 0;
  }

  return startTimeToNumber;
};
